import { http, delay, HttpResponse } from 'msw';
import { API_BASE_URL } from 'src/api/api-base';
import { endpoints } from 'src/config/endpoints';
import Yard from 'src/models/yard';
import { Yards } from 'src/fixtures/yards';

export default [
  http.get(API_BASE_URL + endpoints.yards.getAll, async () => {
    await delay('real');
    return HttpResponse.json({ Data: Yards });
  }),
  http.post(API_BASE_URL + endpoints.yards.create, async (req) => {
    await delay('real');

    const yard = (await req.request.json()) as Yard;
    Yards.push(yard);

    return HttpResponse.json({ Data: yard });
  }),
  http.put(API_BASE_URL + endpoints.yards.update(':yardId'), async (req) => {
    await delay('real');

    const yard = (await req.request.json()) as Yard;
    return HttpResponse.json({ Data: yard });
  }),
  http.delete(API_BASE_URL + endpoints.yards.delete(':yardId'), async (req) => {
    await delay('real');

    const { yardId } = req.params;
    const index = Yards.findIndex((yard) => yard.id === Number(yardId));
    Yards.splice(index, 1);

    return HttpResponse.json({});
  }),
];
